import service from './../service.js';

export default {
    request(type, name = null, email = null, mobile = null, pin = null) {
        return service.post('support/otp', {
            type: type,
            name: name,
            email: email,
            mobile: mobile,
            pin: pin,
        });
    },
    
    validate(type, pin, otp) {
        return service.post('support/otp/validate', {
            type: type,
            pin: pin,
            otp: otp,
        });
    },
}